'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  default: {
    width: '100%',
    cursor: 'pointer',
    WebkitUserSelect: 'none',
    userSelect: 'none',
    flex: 1
  },
  active: {},
  accept: {},
  reject: {}
};